import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

export const titleTypography = (breakpoints) => ({
  fontSize: `${16}px`,
  fontWeight: `${700}`,
  color: colors.textColors.primary,
  textTransform: "uppercase",

  ...(breakpoints && {
    "@media (max-width:1600px)": {
      fontSize: pxToRem(16),
    },
  }),
});

export const descriptionTypography = (breakpoints) => ({
  fontSize: `${14}px`,
  fontWeight: `${400}`,
  color: colors.textColors.primary,

  "@media (max-width:1600px)": {
    fontSize: pxToRem(12),
  },
});

export const noteTypography = (breakpoints) => ({
  fontSize: `${12}px`,
  fontWeight: `${400}`,
  color: colors.textColors.secondary,

  "@media (max-width:1600px)": {
    fontSize: pxToRem(10),
  },
});
